module.exports = __webpack_public_path__ + "img/bg.1cabd7c8.png";